function floatTo16BitPCM(float32Array) {
    const int16Array = new Int16Array(float32Array.length);
    for(let i = 0; i < float32Array.length; i++){
        const value = Math.max(-1, Math.min(1, float32Array[i]));
        int16Array[i] = value < 0 ? 0x8000 * value : 0x7fff * value;
    }
    return int16Array;
}
function convertPCM16ToBase64(pcm16Array) {
    let binaryString = '';
    for(let i = 0; i < pcm16Array.length; i++){
        const value = pcm16Array[i];
        binaryString += String.fromCharCode(0xff & value, value >> 8 & 0xff);
    }
    return btoa(binaryString);
}
function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for(let i = 0; i < len; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes.buffer;
}
function convertPCM16ToFloat32(pcm16Array) {
    const float32Array = new Float32Array(pcm16Array.length);
    for(let i = 0; i < pcm16Array.length; i++)float32Array[i] = pcm16Array[i] / 32768;
    return float32Array;
}
export { base64ToArrayBuffer, convertPCM16ToBase64, convertPCM16ToFloat32, floatTo16BitPCM };
